import type { ReactNode } from 'react';

export const symbol_music_history: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M349-309q-29-29-29-71t29-71q29-29 71-29 17 0 32 5t28 15v-185q0-6 4.5-10.5T495-660h130q6 0 10.5 4.5T640-645v50q0 6-4.5 10.5T625-580H520v200q0 42-29 71t-71 29q-42 0-71-29Zm499.5-15Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5q-73-31.5-127.5-86t-85.5-128Q80-399 80-482q0-16 9.5-23.5T110-513q11 0 20.5 7.5T140-483q-2 143 97.5 243.5T480-139q142 0 241-99t99-241q0-142-99-241t-241-99q-100 0-180.5 51.5T177-633h99q13 0 21.5 8.5T306-603q0 13-8.5 21.5T276-573H110q-13 0-21.5-8.5T80-603v-167q0-13 8.5-21.5T110-800q13 0 21.5 8.5T140-770v79q54-86 142.5-137.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156Z"
		/>
	</svg>
);
